import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, byteSize, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './good-governanace.reducer';

export const GoodGovernanaceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const goodGovernanaceEntity = useAppSelector(state => state.goodGovernanace.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="goodGovernanaceDetailsHeading">
          <Translate contentKey="fivePlusApp.goodGovernanace.detail.title">GoodGovernanace</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{goodGovernanaceEntity.id}</dd>
          <dt>
            <span id="imageName">
              <Translate contentKey="fivePlusApp.goodGovernanace.imageName">Image Name</Translate>
            </span>
          </dt>
          <dd>{goodGovernanaceEntity.imageName}</dd>
          <dt>
            <span id="topics">
              <Translate contentKey="fivePlusApp.goodGovernanace.topics">Topics</Translate>
            </span>
          </dt>
          <dd>{goodGovernanaceEntity.topics}</dd>
          <dt>
            <span id="approved">
              <Translate contentKey="fivePlusApp.goodGovernanace.approved">Approved</Translate>
            </span>
          </dt>
          <dd>{goodGovernanaceEntity.approved ? 'true' : 'false'}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fivePlusApp.goodGovernanace.description">Description</Translate>
            </span>
          </dt>
          <dd>{goodGovernanaceEntity.description}</dd>
          <dt>
            <span id="link">
              <Translate contentKey="fivePlusApp.goodGovernanace.link">Link</Translate>
            </span>
          </dt>
          <dd>{goodGovernanaceEntity.link}</dd>
          <dt>
            <span id="createdDate">
              <Translate contentKey="fivePlusApp.goodGovernanace.createdDate">Created Date</Translate>
            </span>
          </dt>
          <dd>
            {goodGovernanaceEntity.createdDate ? (
              <TextFormat value={goodGovernanaceEntity.createdDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="modifiedDate">
              <Translate contentKey="fivePlusApp.goodGovernanace.modifiedDate">Modified Date</Translate>
            </span>
          </dt>
          <dd>
            {goodGovernanaceEntity.modifiedDate ? (
              <TextFormat value={goodGovernanaceEntity.modifiedDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="fivePlusApp.goodGovernanace.user">User</Translate>
          </dt>
          <dd>{goodGovernanaceEntity.user ? goodGovernanaceEntity.user.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/good-governanace" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/good-governanace/${goodGovernanaceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default GoodGovernanaceDetail;
